// Autogenerated file
export const fuelCardTypesEnum = {
    NoCard: "NoCard",
    Gazpromneft: "Gazpromneft",
    Azimuth: "Azimuth",
    Rosneft: "Rosneft",
    Tatneft: "Tatneft",
    RusPetrol: "RusPetrol",
    Lukoil: "Lukoil",
    Vladnefteresurs: "Vladnefteresurs",
    Irbis: "Irbis",
    PetrolPlus: "PetrolPlus",
    Taif: "Taif",
    DelkOil: "DelkOil",
};
export const fuelCardTypes = [
    { label: "Без карты", value: "NoCard" },
    { label: "Газпромнефть", value: "Gazpromneft" },
    { label: "Азимут", value: "Azimuth" },
    { label: "Роснефть", value: "Rosneft" },
    { label: "Татнефть", value: "Tatneft" },
    { label: "РусПетрол", value: "RusPetrol" },
    { label: "Лукойл", value: "Lukoil" },
    { label: "Владнефтересурс", value: "Vladnefteresurs" },
    { label: "Ирбис", value: "Irbis" },
    { label: "ППР", value: "PetrolPlus" },
    { label: "ТАИФ", value: "Taif" },
    { label: "Делкойл", value: "DelkOil" },
];
